module.exports = __webpack_public_path__ + "media/img/Scholarships2u-Logo-7272d276f7747badd55c4a3e2b782535.svg";